import "./App.css";
import "./styles/media.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { WhatsApp } from "./components/WhatsApp";
import Home from "./pages/Home";
import About from "./pages/About";
import Clients from "./pages/Clients";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Project from "./pages/Project";
import { SiteImagesProvider } from "./components/SiteImages";

function StudioRoutes() {
    const location = useLocation();
    useEffect(() => {
        const titles = { "/": "Visual Merchandising, Branding & Signage", "/about": "About the Studio", "/clients": "Our Clients", "/contact": "Contact Us", "/admin": "Studio Admin" };
        document.title = `Decorcrafts — ${titles[location.pathname] || (location.pathname.startsWith("/admin/") ? "Studio Admin" : "Selected Work")} · New Delhi`;
        const frame = requestAnimationFrame(() => {
            const target = location.hash && document.getElementById(decodeURIComponent(location.hash.slice(1)));
            if (target) target.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth", block: "start" });
            else window.scrollTo({ top: 0, behavior: "instant" });
        });
        return () => cancelAnimationFrame(frame);
    }, [location]);
    return <Routes><Route path="/" element={<Home />} /><Route path="/about" element={<About />} /><Route path="/clients" element={<Clients />} /><Route path="/contact" element={<Contact />} /><Route path="/admin/*" element={<Admin />} /><Route path="/work/:slug" element={<Project />} /><Route path="*" element={<Home />} /></Routes>;
}

export default function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 0.85, smoothWheel: true, autoRaf: true, anchors: false });
        return () => lenis.destroy();
    }, []);
    return <BrowserRouter><SiteImagesProvider><Navbar /><StudioRoutes /><Footer /><WhatsApp /></SiteImagesProvider></BrowserRouter>;
}